module.exports = __webpack_public_path__ + "static/media/banner-desktop.fec887b1.jpg";